export default function LoadingSpinner() {
  return (
    <div className="spinner-container">
      <div className="loading-spinner border-brand-900"></div>
    </div>
  );
}
